
const initGoogleCodeClient = (onSuccess, onFailed) => {
    return window["google"] ? google.accounts.oauth2.initCodeClient({
        client_id: "81613237558-fo8l4ifkb5baergh3elk8s0q8lpld9dj.apps.googleusercontent.com",
        scope: "profile email",
        ux_mode: "popup",
        callback: onSuccess,
        error_callback: onFailed
    }): (onFailed ? onFailed(): null)
}

const initGoogleTokenClient = (onSuccess, onFailed) => {
    return window["google"] ? google.accounts.oauth2.initTokenClient({
        client_id: "81613237558-fo8l4ifkb5baergh3elk8s0q8lpld9dj.apps.googleusercontent.com",
        scope: "profile email",
        callback: onSuccess,
        error_callback: onFailed
    }): ( onFailed ? onFailed(): null )
}

const requestCode = (client) => {
    client && client.requestCode();
}

const requestAccessToken = (client) => {
    client && client.requestAccessToken();
}

export default {
    initGoogleCodeClient: initGoogleCodeClient,
    initGoogleTokenClient: initGoogleTokenClient,
    requestCode: requestCode,
    requestAccessToken: requestAccessToken
}



// WEBPACK FOOTER //
// ./src/network/google.js